<template>
	<div style="background:white">
    <van-nav-bar title="门店位置" left-arrow @click-left="$router.back()" left-text="返回" />
		<van-row>
			<van-col span="24">
				<a href="/home"><img style="float: left; " src="@/assets/page/title.gif" /></a>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24"><img style="float: left; " src="@/assets/page/bn1.gif" /></van-col>
		</van-row>

		<van-row>
			<van-col span="24">
				<a href="tel:4008965569"><img style="float: left; " src="@/assets/page/tel_2.gif" /></a>
			</van-col>
		</van-row>
		<van-row><van-col span="24" style="text-align: center;font-family: 黑体; font-size: 25px;height: 50px;line-height: 50px;">门店位置</van-col></van-row>
		<van-row>
			<van-col span="24" style="text-align: center;font-family: 黑体; font-size: 10px;height: 10px;line-height: 10px;margin-bottom: 10px;">（按拼音首字母排序）</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="margin-bottom: 20px; text-align: center;font-family: 黑体; font-size: 20px;height: 20px;line-height: 20px;">
				点击电话号码即可联系分公司
			</van-col>
		</van-row>

		<van-row style="margin:0 20px;color:  white ;background: #97C211;height: 50px;line-height: 50px;font-weight: 900;font-size: 20px;">
			<van-col span="8">分公司</van-col>
			<van-col span="8">地址</van-col>
			<van-col span="8">电话</van-col>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">朝阳区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 100px;line-height: 100px;">安贞</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 100px;line-height: 50px;padding-left: 4px;">北京市朝阳区安贞里冶金报社307/308/322室</van-col>
			<a href="tel:64432810"><van-col span="6" style="text-align:center;background:#ECECEC;height: 100px;line-height: 100px;color:#0099FF ;">64432810</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">国贸</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市朝阳区南郎家园18号恋日国际1703/1712/1713/1715室
			</van-col>
			<a href="tel:65674740"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">65674740</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;">劲松</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 140px;line-height: 50px;padding-left: 4px;">北京市朝阳区劲松南路1号海文大厦639/648/649室</van-col>
			<a href="tel:67731180"><van-col span="6" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;color:#0099FF ;">67731180</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">十里堡</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市朝阳区建国路15号院甲1号北岸1292三间房创意生活园区408
			</van-col>
			<a href="tel:65583961"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">65583961</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;">霄云路</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 140px;line-height: 70px;padding-left: 4px;">北京市朝阳区霄云路21号嘉里大通物流中心505室</van-col>
			<a href="tel:64642114"><van-col span="6" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;color:#0099FF ;">64642114</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">望京</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">北京市朝阳区望京西园222号楼星源国际B座2802室</van-col>
			<a href="tel:64399838"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">64399838</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;">亚运村</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 140px;line-height: 70px;padding-left: 4px;">北京市朝阳区欧陆经典16号楼1306室</van-col>
			<a href="tel:84853015"><van-col span="6" style="text-align:center;background:#ECECEC;height: 140px;line-height: 140px;color:#0099FF ;">84853015</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">海淀区</van-col></van-row>

		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">上地</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 70px;padding-left: 4px;">北京市海淀区信息路15号702室（金融科贸大厦）</van-col>
			<a href="tel:82784286"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">82784286</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">双安</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 50px;padding-left: 4px;">北京市海淀区北三环西路48号科技会展中心2号楼8A</van-col>
			<a href="tel:51627951"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">51627951</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 50px;">远大路（原公主坟</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 70px;padding-left: 4px;">北京市海淀区四季青路8号郦城工作区816-817室</van-col>
			<a href="tel:53119311"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">53119311</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">中关村</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 70px;padding-left: 4px;">北京市海淀区四季青路8号郦城工作区816-817室</van-col>
			<a href="tel:53119300"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">53119300</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">东城区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">东四</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 70px;padding-left: 4px;">北京市东城区金宝街67号隆基大厦南楼603室</van-col>
			<a href="tel:65287027"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">65287027</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">西城区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">阜成门</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">北京市西城区阜成门外大街1号四川大厦东塔1206室</van-col>
			<a href="tel:88337736"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">88337736</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">宣武</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市西城区核桃园西街36号北方长城光电5层509室
			</van-col>
			<a href="tel:83513870"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">83513870</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">丰台区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">丰台</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市丰台区西四环南路88号赛欧科园科技孵化中心201室
			</van-col>
			<a href="tel:56252180"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">56252180</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">洋桥</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市丰台区马家堡东路55号政洋大厦309、316和318
			</van-col>
			<a href="tel:67527846"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">67527846</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">石景山区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">石景山</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市石景山区阜石路166号泽洋大厦12层1215、1216室
			</van-col>
			<a href="tel:88707597"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">88707597</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">大兴区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">大兴</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 70px;padding-left: 4px;">北京市大兴区清城北里27号楼C座2208室</van-col>
			<a href="tel:69294979"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">69294979</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">亦庄</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市大兴区经济技术开发区天华园二里二区20幢（大雄公寓）310室
			</van-col>
			<a href="tel:67866946"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">67866946</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">门头沟区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">门头沟</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市门头沟区滨河路115号国信滨河大厦1312A ，1312B， 1318室
			</van-col>
			<a href="tel:61805088"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">61805088</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 70px;">门头沟大厅</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height:70px;padding-left: 4px;">北京市门头沟区滨河西区霁月园153-28</van-col>
			<a href="tel:69820476"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">69820476</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">通州区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">通州</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 70px;padding-left: 4px;">北京市通州区运河西大街123号</van-col>
			<a href="tel:80502711"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">80502711</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 70px;">通州大厅</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height:70px;padding-left: 4px;">北京市通州区新华北街75号18号</van-col>
			<a href="tel:80502711"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">80502711</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">昌平区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">昌平</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 70px;padding-left: 4px;">北京市昌平区龙水路四越写字楼一层888/188室</van-col>
			<a href="tel:60745340"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">60745340</van-col></a>
		</van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;">回龙观</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height:50px;padding-left: 4px;">
				北京市昌平区回龙观西大街美廉美对面琥珀天地1单元506/538室
			</van-col>
			<a href="tel:57536939"><van-col span="6" style="text-align:center;background:#ECECEC;height: 150px;line-height: 150px;color:#0099FF ;">57536939</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">房山区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">房山</van-col>
			<van-col span="14" style="text-align:left;background:#ECECEC;height: 150px;line-height: 50px;padding-left: 4px;">
				北京市房山区良乡拱辰南大街1号华亨国际中心507室
			</van-col>
			<a href="tel:69385658"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">69385658</van-col></a>
		</van-row>
		<van-row style="background:#D9D9D9;height: 50px;line-height: 50px;margin: 0 20px;"><van-col span="24">顺义区</van-col></van-row>
		<van-row style="margin: 0 20px;">
			<van-col span="4" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;">顺义</van-col>
			<van-col span="14" style="text-align:left;background:#F7F7F7;height: 150px;line-height: 70px;padding-left: 4px;">北京市顺义区石园南区33号楼4单元302室</van-col>
			<a href="tel:89440073"><van-col span="6" style="text-align:center;background:#E6E6E6;height: 150px;line-height: 150px;color:#0099FF ;">89440073</van-col></a>
		</van-row>

		<van-row style="margin:5px 20px;">
  <van-col span="24"><img src="@/assets/page/site.jpg" alt=""></van-col>

</van-row>
	</div>
</template>

<script>
export default {
	name: 'page5',
	data() {
		return {};
	}
};
</script>

<style scoped="scoped">
img {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/address.vue